export default {
  // path
  'pathLogin': '/login',
  'pathLogout': '/logout',
  'pathForgotPassword': '/forgot-password',
  'pathChangePassword': '/change-password',
  'pathContactUs': '/contact-us',
  'pathSelectBuilding': '/select-building',
  'pathAccountingReport': '/accounting-report/:buildingID/:buildingRefNo',
  'pathManageMembership': '/manage-membership/:buildingID',
  'pathManageTenantMembership': '/manage-membership/:buildingID/:buildingRefNo/:tenantName',
  'pathTenantManagement': '/tenant-management/:buildingID/:buildingRefNo',
  'pathSearchVehicleLicensePlate': '/check-status/:buildingID/search-car-plate',
  'pathParkingStatus': '/check-status/:buildingID/parking-status',
  'pathOperationReport': '/operation-report/:buildingID/:buildingRefNo',
  'pathExportOperationReport': '/export-operation-report/:buildingID/:buildingRefNo',
  'pathServerError': '/server-error',
  'pathCheckRedirect': '/',
  'pathUserManagement': '/user-management/:buildingID/:buildingRefNo',
  'pathOperationDashboard': '/operation-dashboard/:buildingRefNo',
  'pathParkingDayConfig': '/parking-day-config/:buildingID/:buildingRefNo',
  'pathCustomDayConfig': '/custom-day-config/:buildingID/:buildingRefNo',
  'pathOnboardForm': '/onbord-form/:buildingID/:buildingRefNo',
  'pathCreateBuilding': '/create-building',  
  'pathEditDraftedBuilding': '/edit-drafted-building/:draftedBuildingID',
  // action type
  // - report
  'GET_ACCOUNTING_REPORT_SUCCESS': 'GET_ACCOUNTING_REPORT_SUCCESS',
  'GET_ACCOUNTING_REPORT_FAILURE': 'GET_ACCOUNTING_REPORT_FAILURE',
  'EXPORT_ACCOUNTING_REPORT_SUCCESS': 'EXPORT_ACCOUNTING_REPORT_SUCCESS',
  'EXPORT_ACCOUNTING_REPORT_FAILURE': 'EXPORT_ACCOUNTING_REPORT_FAILURE',
  'GET_PARKING_REPORT_SUCCESS': 'GET_PARKING_REPORT_SUCCESS',
  'GET_PARKING_REPORT_FAILURE': 'GET_PARKING_REPORT_FAILURE',
  'EXPORT_VEHICLE_MOVEMENT_OPERATION_REPORT_SUCCESS': 'EXPORT_VEHICLE_MOVEMENT_OPERATION_REPORT_SUCCESS',
  'EXPORT_VEHICLE_MOVEMENT_OPERATION_REPORT_FAILURE': 'EXPORT_VEHICLE_MOVEMENT_OPERATION_REPORT_FAILURE',
  'EXPORT_REDEMPTION_OPERATION_REPORT_SUCCESS': 'EXPORT_REDEMPTION_OPERATION_REPORT_SUCCESS',
  'EXPORT_REDEMPTION_OPERATION_REPORT_FAILURE': 'EXPORT_REDEMPTION_OPERATION_REPORT_FAILURE',
  'EXPORT_MEMBER_MOVEMENT_OPERATION_REPORT_SUCCESS': 'EXPORT_MEMBER_MOVEMENT_OPERATION_REPORT_SUCCESS',
  'EXPORT_MEMBER_MOVEMENT_OPERATION_REPORT_FAILURE': 'EXPORT_MEMBER_MOVEMENT_OPERATION_REPORT_FAILURE',
  'GET_MEMBERSHIP_REPORT_SUCCESS': 'GET_MEMBERSHIP_REPORT_SUCCESS',
  'GET_MEMBERSHIP_REPORT_FAILURE': 'GET_MEMBERSHIP_REPORT_FAILURE',
  // - building
  'GET_BUILDING_SUCCESS': 'GET_BUILDING_SUCCESS',
  'GET_BUILDING_FAILURE': 'GET_BUILDING_FAILURE',
  'GET_BUILDING_BY_SEARCH_SUCCESS': 'GET_BUILDING_BY_SEARCH_SUCCESS',
  'GET_BUILDING_BY_SEARCH_FAILURE': 'GET_BUILDING_FAILURE',
  'GET_BUILDING_BY_ID_SUCCESS': 'GET_BUILDING_BY_ID_SUCCESS',
  'GET_BUILDING_BY_ID_FAILURE': 'GET_BUILDING_BY_ID_FAILURE',
  'GET_DRAFT_BUILDING_SUCCESS': 'GET_DRAFT_BUILDING_SUCCESS',
  'GET_DRAFT_BUILDING_FAILURE': 'GET_DRAFT_BUILDING_FAILURE',
  'CREATE_DRAFT_BUILDING_SUCCESS': 'CREATE_DRAFT_BUILDING_SUCCESS',
  'CREATE_DRAFT_BUILDING_FAILURE': 'CREATE_DRAFT_BUILDING_FAILURE',
  'CREATE_BUILDING_SUCCESS': 'CREATE_BUILDING_SUCCESS',
  'CREATE_BUILDING_FAILURE': 'CREATE_BUILDING_FAILURE',
  'UPDATE_BUILDING_SUCCESS': 'UPDATE_BUILDING_SUCCESS',
  'UPDATE_BUILDING_FAILURE': 'UPDATE_BUILDING_FAILURE',
  // - authen
  'LOGIN_SUCCESS': 'LOGIN_SUCCESS',
  'LOGIN_FAILURE': 'LOGIN_FAILURE',
  'LOGOUT_SUCCESS': 'LOGOUT_SUCCESS',
  'LOGOUT_FAILURE': 'LOGOUT_FAILURE',
  'REFRESH_TOKEN_SUCCESS': 'REFRESH_TOKEN_SUCCESS',
  'REFRESH_TOKEN_FAILURE': 'REFRESH_TOKEN_FAILURE',
  // - profile
  'GET_PROFILE_SUCCESS': 'GET_PROFILE_SUCCESS',
  'GET_PROFILE_FAILURE': 'GET_PROFILE_FAILURE',
  'UPDATE_PROFILE_SUCCESS': 'UPDATE_PROFILE_SUCCESS',
  'UPDATE_PROFILE_FAILURE': 'UPDATE_PROFILE_FAILURE',
  // - car plate
  'GET_LICENSE_PLATE_SUCCESS': 'GET_LICENSE_PLATE_SUCCESS',
  'GET_LICENSE_PLATE_FAILURE': 'GET_LICENSE_PLATE_FAILURE',
  'SEARCH_CAR_PLATE_SUCCESS': 'SEARCH_CAR_PLATE_SUCCESS',
  'SEARCH_CAR_PLATE_FAILURE': 'SEARCH_CAR_PLATE_FAILURE',
  // - parking
  'GET_PARKING_STATUS_SUCCESS': 'GET_PARKING_STATUS_SUCCESS',
  'GET_PARKING_STATUS_FAILURE': 'GET_PARKING_STATUS_FAILURE',
  'GET_PARKING_STATUS_BY_ID_SUCCESS': 'GET_PARKING_STATUS_BY_ID_SUCCESS',
  'GET_PARKING_STATUS_BY_ID_FAILURE': 'GET_PARKING_STATUS_BY_ID_FAILURE',
  'CREATE_PARKING_SUCCESS': 'CREATE_PARKING_SUCCESS',
  'CREATE_PARKING_FAILURE': 'CREATE_PARKING_FAILURE',
  'UPDATE_STATUS_CAR_EXIT_SUCCESS': 'UPDATE_STATUS_CAR_EXIT_SUCCESS',
  'UPDATE_STATUS_CAR_EXIT_FAILURE': 'UPDATE_STATUS_CAR_EXIT_FAILURE',
  // - problems
  'GET_PARKING_PROBLEMS_SUCCESS': 'GET_PARKING_PROBLEMS_SUCCESS',
  'GET_PARKING_PROBLEMS_FAILURE': 'GET_PARKING_PROBLEMS_FAILURE',
  'GET_PROBLEMS_SUCCESS': 'GET_PROBLEMS_SUCCESS',
  'GET_PROBLEMS_FAILURE': 'GET_PROBLEMS_FAILURE',
  'CREATE_PROBLEM_SUCCESS': 'CREATE_PROBLEM_SUCCESS',
  'CREATE_PROBLEM_FAILURE': 'CREATE_PROBLEM_FAILURE',
  'UPDATE_PROBLEM_SUCCESS': 'UPDATE_PROBLEM_SUCCESS',
  'UPDATE_PROBLEM_FAILURE': 'UPDATE_PROBLEM_FAILURE',
  'DELETE_PROBLEM_SUCCESS': 'DELETE_PROBLEM_SUCCESS',
  'DELETE_PROBLEM_FAILURE': 'DELETE_PROBLEM_FAILURE',
  // - payment
  'CREATE_PAYMENT_SUCCESS': 'CREATE_PAYMENT_SUCCESS',
  'CREATE_PAYMENT_FAILURE': 'CREATE_PAYMENT_FAILURE',
  'UPDATE_PAYMENT_SUCCESS': 'UPDATE_PAYMENT_SUCCESS',
  'UPDATE_PAYMENT_FAILURE': 'UPDATE_PAYMENT_FAILURE',
  'GET_PAYMENT_DETAIL_SUCCESS': 'GET_PAYMENT_DETAIL_SUCCESS',
  'GET_PAYMENT_DETAIL_FAILURE': 'GET_PAYMENT_DETAIL_FAILURE',
  // - user
  'GET_USERS_SUCCESS': 'GET_USERS_SUCCESS',
  'GET_USERS_FAILURE': 'GET_USERS_FAILURE',
  'CREATE_USER_SUCCESS': 'CREATE_USER_SUCCESS',
  'CREATE_USER_FAILURE': 'CREATE_USER_FAILURE',
  'UPDATE_USER_SUCCESS': 'UPDATE_USER_SUCCESS',
  'UPDATE_USER_FAILURE': 'UPDATE_USER_FAILURE',
  'CLEAR_CREATE_USER_SUCCESS': 'CLEAR_CREATE_USER_SUCCESS',
  'CLEAR_CREATE_USER_FAILURE': 'CLEAR_CREATE_USER_FAILURE',
  'CLEAR_UPDATE_USER_SUCCESS': 'CLEAR_UPDATE_USER_SUCCESS',
  'CLEAR_UPDATE_USER_FAILURE': 'CLEAR_UPDATE_USER_FAILURE',
  'GET_USER_ROLES_SUCCESS': 'GET_USER_ROLES_SUCCESS',
  'GET_USER_ROLES_FAILURE': 'GET_USER_ROLES_FAILURE',
  'RESET_USER_PASSWORD_SUCCESS': 'RESET_USER_PASSWORD_SUCCESS',
  'RESET_USER_PASSWORD_FAILURE': 'RESET_USER_PASSWORD_FAILURE',
  'CLEAR_RESET_USER_PASSWORD_SUCCESS': 'CLEAR_RESET_USER_PASSWORD_SUCCESS',
  'CLEAR_RESET_USER_PASSWORD_FAILURE': 'CLEAR_RESET_USER_PASSWORD_FAILURE',
  // - membership
  'GET_MEMBERSHIP_PACKAGE_SUCCESS': 'GET_MEMBERSHIP_PACKAGE_SUCCESS',
  'GET_MEMBERSHIP_PACKAGE_FAILURE': 'GET_MEMBERSHIP_PACKAGE_FAILURE',
  'CREATE_MEMBERSHIP_SUCCESS': 'CREATE_MEMBERSHIP_SUCCESS',
  'CREATE_MEMBERSHIP_FAILURE': 'CREATE_MEMBERSHIP_FAILURE',
  'GET_MEMBERSHIP_DETAIL_PACKAGE_SUCCESS': 'GET_MEMBERSHIP_DETAIL_PACKAGE_SUCCESS',
  'GET_MEMBERSHIP_DETAIL_PACKAGE_FAILURE': 'GET_MEMBERSHIP_DETAIL_PACKAGE_FAILURE',
  'UPDATE_MEMBERSHIP_SUCCESS': 'UPDATE_MEMBERSHIP_SUCCESS',
  'UPDATE_MEMBERSHIP_FAILURE': 'UPDATE_MEMBERSHIP_FAILURE',
  'GET_TENANT_SUCCESS': 'GET_TENANT_SUCCESS',
  'GET_TENANT_FAILURE': 'GET_TENANT_FAILURE',
  'CREATE_TENANT_SUCCESS': 'CREATE_TENANT_SUCCESS',
  'CREATE_TENANT_FAILURE': 'CREATE_TENANT_FAILURE',
  'UPDATE_TENANT_SUCCESS': 'UPDATE_TENANT_SUCCESS',
  'UPDATE_TENANT_FAILURE': 'UPDATE_TENANT_FAILURE',
  // - company
  'GET_COMPANY_SUCCESS': 'GET_COMPANY_SUCCESS',
  'GET_COMPANY_FAILURE': 'GET_COMPANY_FAILURE',
  // - search
  'SEARCH_VEHICLE_PLATE_OR_COMPANY_NAME_IN_BUILDING_SUCCESS': 'SEARCH_VEHICLE_PLATE_OR_COMPANY_NAME_IN_BUILDING_SUCCESS',
  'SEARCH_VEHICLE_PLATE_OR_COMPANY_NAME_IN_BUILDING_FAILURE': 'SEARCH_VEHICLE_PLATE_OR_COMPANY_NAME_IN_BUILDING_FAILURE',
  'ACCOUNT_SEARCH_VEHICLE_PLATE_OR_REFERENCE_CODE_SUCCESS': 'ACCOUNT_SEARCH_VEHICLE_PLATE_OR_REFERENCE_CODE_SUCCESS',
  'ACCOUNT_SEARCH_VEHICLE_PLATE_OR_REFERENCE_CODE_FAILURE': 'ACCOUNT_SEARCH_VEHICLE_PLATE_OR_REFERENCE_CODE_FAILURE',
  'SEARCH_VEHICLE_PLATE_OR_PARKING_REF_IN_OPERATION_REPORT_SUCCESS': 'SEARCH_VEHICLE_PLATE_OR_PARKING_REF_IN_OPERATION_REPORT_SUCCESS',
  'SEARCH_VEHICLE_PLATE_OR_PARKING_REF_IN_OPERATION_REPORT_FAILURE': 'SEARCH_VEHICLE_PLATE_OR_PARKING_REF_IN_OPERATION_REPORT_FAILURE',
  'SEARCH_VEHICLE_TYPE_SUCCESS': 'SEARCH_VEHICLE_TYPE_SUCCESS',
  'SEARCH_VEHICLE_TYPE_FAILURE': 'SEARCH_VEHICLE_TYPE_FAILURE',
  'SEARCH_VEHICLE_PLATE_IN_BUILDING_SUCCESS': 'SEARCH_VEHICLE_PLATE_IN_BUILDING_SUCCESS',
  'SEARCH_VEHICLE_PLATE_IN_BUILDING_FAILURE': 'SEARCH_VEHICLE_PLATE_IN_BUILDING_FAILURE',
  'SEARCH_COMPANY_NAME_IN_BUILDING_SUCCESS': 'SEARCH_COMPANY_NAME_IN_BUILDING_SUCCESS',
  'SEARCH_COMPANY_NAME_IN_BUILDING_FAILURE': 'SEARCH_COMPANY_NAME_IN_BUILDING_FAILURE',
  'SEARCH_MEMBER_NAME_IN_BUILDING_SUCCESS': 'SEARCH_MEMBER_NAME_IN_BUILDING_SUCCESS',
  'SEARCH_MEMBER_NAME_IN_BUILDING_FAILURE': 'SEARCH_MEMBER_NAME_IN_BUILDING_FAILURE',
  // - error
  'SHOW_ERROR_MESSAGE': 'SHOW_ERROR_MESSAGE',
  'HIDE_ERROR_MESSAGE': 'HIDE_ERROR_MESSAGE',
  // - IoT
  'GET_IOT_DEVICES_SUCCESS': 'GET_IOT_DEVICES_SUCCESS',
  'GET_IOT_DEVICES_FAILURE': 'GET_IOT_DEVICES_FAILURE',
  'PUBLISH_IOT_INFORMATION_SUCCESS': 'PUBLISH_IOT_INFORMATION_SUCCESS',
  'PUBLISH_IOT_INFORMATION_FAILURE': 'PUBLISH_IOT_INFORMATION_FAILURE',
  // - create building
  'SET_BUILDING_PARKING_FEE_MODEL_CAR_SUCCESS': 'SET_BUILDING_PARKING_FEE_MODEL_CAR_SUCCESS',
  'SET_BUILDING_PARKING_FEE_MODEL_CAR_FAILURE': 'SET_BUILDING_PARKING_FEE_MODEL_CAR_FAILURE',
  'SET_BUILDING_PARKING_FEE_MODEL_MOTORCYCLE_SUCCESS': 'SET_BUILDING_PARKING_FEE_MODEL_MOTORCYCLE_SUCCESS',
  'SET_BUILDING_PARKING_FEE_MODEL_MOTORCYCLE_FAILURE': 'SET_BUILDING_PARKING_FEE_MODEL_MOTORCYCLE_FAILURE',
  'SET_BUILDING_INFORMATION_SUCCESS': 'SET_BUILDING_INFORMATION_SUCCESS',
  'SET_BUILDING_INFORMATION_FAILURE': 'SET_BUILDING_INFORMATION_FAILURE',
  'SET_REDEMPTION_MODEL_INFORMATION_SUCCESS': 'SET_REDEMPTION_MODEL_INFORMATION_SUCCESS',
  'SET_REDEMPTION_MODEL_INFORMATION_FAILURE': 'SET_REDEMPTION_MODEL_INFORMATION_FAILURE',
  'SET_CONFIG_COMMON_SUCCESS': 'SET_CONFIG_COMMON_SUCCESS',
  'SET_CONFIG_COMMON_FAILURE': 'SET_CONFIG_COMMON_FAILURE',
  'SET_CONFIG_SUCCESS': 'SET_CONFIG_SUCCESS',
  'SET_CONFIG_FAILURE': 'SET_CONFIG_FAILURE',
  'SET_BUILDING_CONTENT_SUCCESS': 'SET_BUILDING_CONTENT_SUCCESS',
  'SET_BUILDING_CONTENT_FAILURE': 'SET_BUILDING_CONTENT_FAILURE',
  'SET_BUILDING_TENANT_SUCCESS': 'SET_BUILDING_TENANT_SUCCESS',
  'SET_BUILDING_TENANT_FAILURE': 'SET_BUILDING_TENANT_FAILURE',
  'SET_BUILDING_BUILDING_IOT_DEVICE_SUCCESS': 'SET_BUILDING_BUILDING_IOT_DEVICE_SUCCESS',
  'SET_BUILDING_BUILDING_IOT_DEVICE_FAILURE': 'SET_BUILDING_BUILDING_IOT_DEVICE_FAILURE',
  'SET_BUILDING_PARKING_DAY_CONFIG_SUCCESS': 'SET_BUILDING_PARKING_DAY_CONFIG_SUCCESS',
  'SET_BUILDING_PARKING_DAY_CONFIG_FAILURE': 'SET_BUILDING_PARKING_DAY_CONFIG_FAILURE',
  'SET_CURRENT_BUILDING_DATA_PATH_SUCCESS': 'SET_CURRENT_BUILDING_DATA_PATH_SUCCESS',
  'SET_CURRENT_BUILDING_DATA_PATH_FAILURE': 'SET_CURRENT_BUILDING_DATA_PATH_FAILURE',
  // - Parking day config
  'GET_PARKING_DAY_CONFIG_SUCCESS': 'GET_PARKING_DAY_CONFIG_SUCCESS',
  'GET_PARKING_DAY_CONFIG_FAILURE': 'GET_PARKING_DAY_CONFIG_FAILURE',
  'UPDATE_PARKING_DAY_CONFIG_SUCCESS': 'UPDATE_PARKING_DAY_CONFIG_SUCCESS',
  'UPDATE_PARKING_DAY_CONFIG_FAILURE': 'UPDATE_PARKING_DAY_CONFIG_FAILURE',
  'CREATE_PARKING_DAY_CONFIG_SUCCESS': 'CREATE_PARKING_DAY_CONFIG_SUCCESS',
  'CREATE_PARKING_DAY_CONFIG_FAILURE': 'CREATE_PARKING_DAY_CONFIG_FAILURE',
  // ENV
  'envDomainAPI': process.env.REACT_APP_DOMAIN_API,
  'envCookieDomain': process.env.REACT_APP_DOMAIN_COOKIE,
  'envVat': parseInt(process.env.REACT_APP_VAT),
  'envDashboardURL': process.env.REACT_APP_DASHBOARD_URL,
  'envCustomParkingDayConfigTemplate': process.env.REACT_APP_CUSTOM_PARKING_DAY_CONFIG_TEMPLATE,
  'envTenantTemplate': process.env.REACT_APP_TENANT_TEMPLATE,
  // default language
  'defaultLanguage': 'th',
  // format date
  'TH': 'th',
  'EN': 'en',
  // vehicle type
  'vehicleTypeCar': 'CAR',
  'vehicleTypeMotorcycle': 'MOTORCYCLE',
  // overnight
  'twentyFourHours': '24_HOURS',
  // customer types
  'customerTypeVisitor': 'VISITOR',
  'customerTypeMember': 'MEMBER',
  // role permission
  'roleSuperAdmin': 'SUPER_ADMIN',
  'roleAccounting': 'ACCOUNTING',
  'roleCashier': 'CASHIER',
  'roleAdmin': 'ADMIN',
  'roleOperation': 'OPERATION',
  // paymentMethod
  'paymentMethodCash': 'CASH',
  'paymentMethodCreditCard': 'CREDIT_CARD',
  'paymentMethodPPMobile': 'PP_MOBILE',
  'paymentMethodPPKiosk': 'PP_KIOSK',
  'paymentMethodPPTablet': 'PP_TABLET',
  'paymentMethodLinePay': 'LINEPAY',
  'paymentMethodPPKioskParkingGate': 'PP_KIOSK_PARKING_GATE',
  // images
  'ezyParkLogo': '/images/ezypark_logo.png',
  'loadingImg': '/images/loading.svg',
  'notFoundImg': '/images/not_found.png',
  'checkImg': '/images/check.png',
  'warningImg': '/images/warning.png',
  'promptpayImg': '/images/promptpay_logo.png',
  'promptpayErrorImg': '/images/promptpay_error.png',
  'promptpaySuccessImg': '/images/promptpay_success.png',
  'dummyCarImg': '/images/dummy_car.png',
  'carOutImg': '/images/car_out.png',
  'locationImage': '/images/location_icon.svg',
  'uploadImage': '/images/upload.svg',
  // css class name bg app
  'removeClassNameBG': '',
  'addClassNameBGBlack': 'bg-black',
  // cookie
  'cookieToken': 'ezypark_token',
  'cookieUserId': 'ezypark_user_id',
  'cookieExpires': 'ezypark_expires',
  // problems
  'createProblem': 'create',
  'updateProblem': 'update',
  'deleteProblem': 'delete',
  'vehicleLicensePlateProblem': 'READ_VEHICLE_LICENSE_PROBLEM',
  'otherProblem': 'OTHER_PROBLEM',
  'barrierProblem': 'GATE_BARRIER_MALFUNCTION_PROBLEM',
  'paymentProblem': 'PAYMENT_PROBLEM',
  'overdueProblem': 'PARKING_FEE_OVERDUE_PROBLEM',
  'physicalDamageProblem': 'VEHICLE_LICENSE_PHYSICAL_DAMAGE_PROBLEM',
  'filterProblemsCashier': 'PAYMENT_PROBLEM,OTHER_PROBLEM',
  // show detail
  'detailParkingStatus': 'status',
  'detailReceipts': 'receipts',
  // payment
  'cashPayment': 'cash',
  'ezyPayment': 'ezy',
  'updatePayment': 'update',
  'warningPayment': 'warning',
  'successPayment': 'success',
  // payment method
  'methodQRCode': 'QR_CODE',
  'methodCash': 'CASH',
  // payment gateway type
  'gatewayKBank': 'KBANK',
  'gatewayManual': 'MANUAL',
  // payment status
  'paymentStatusPaid': 'PAID',
  'paymentStatusReady': 'READY',
  // parking status
  'parkingStatusIn': 'IN',
  'parkingStatusOut': 'OUT',
  // member status
  'memberStatusActive': 'ACTIVE',
  'memberStatusInActive': 'INACTIVE',
  'memberStatusExpired': 'EXPIRED',
  // vehicle status
  'vehicleStatusActive': 'ACTIVE',
  'vehicleStatusInActive': 'INACTIVE',
  // day type
  'dayTypeWeekday': 'WEEKDAY',
  'dayTypeWeekend': 'WEEKEND',
  'dayTypeCustom': 'CUSTOM',
  // charge type
  'chargeTypeVisitor': 'VISITOR',
  'chargeTypeMember': 'MEMBER',
  'chargeTypeVisitorMember': 'VISITOR_MEMBER',
  'chargeTypeNoCharge': 'NO_CHARGE',
  // Parking fee model type
  'flatRate': 'FLAT_RATE',
  'stepRate': 'STEP_RATE',
  // car type
  'vehicleType': [
    { 'label': 'รถยนต์', 'value': 'CAR' },
    { 'label': 'รถจักรยานยนต์', 'value': 'MOTORCYCLE' },
  ],
  'status': [
    { 'label': 'Active', 'value': 'ACTIVE' },
    { 'label': 'Inactive', 'value': 'INACTIVE' },
  ],
  // parking model
  'parkingModelType': [
    { 'label': 'Flat rate', 'value': 'FLAT_RATE' },
    { 'label': 'Step rate', 'value': 'STEP_RATE' },
  ],
  'parkingTimePeriodType': [
    { 'label': 'All day', 'value': 'ALL_DAY' },
    { 'label': 'Custom', 'value': 'CUSTOM' },
  ],
  'buildingFreeParkingCondition': [
    { 'label': 'Free in determine period', 'value': 'FREE_IN_DETERMINE_PERIOD' },
    { 'label': 'parking time deduction', 'value': 'PARKING_TIME_DEDUCTION' },
  ],
  'overnightChargeType': [
    { 'label': 'Time period', 'value': 'TIME_PERIOD' },
    { 'label': '24 hours', 'value': '24_HOURS' },
  ],
  'displayVehicleParkingFee' : [
    { 'label': 'Car', 'value': 'CAR' },
    { 'label': 'Motorcycle', 'value': 'MOTORCYCLE' },
    { 'label': 'Car & Motorcycle', 'value': 'CAR_MOTORCYCLE' },
  ],
  'parkingDayConfigMemberType': [
    { 'label': 'Visitor', 'value': 'VISITOR' },
    { 'label': 'Member', 'value': 'MEMBER' },
    { 'label': 'Visitor & Member', 'value': 'VISITOR_MEMBER' },
  ],
  'parkingDayConfigChargeCustomerType': [
    { 'label': 'Visitor', 'value': 'VISITOR' },
    { 'label': 'Member', 'value': 'MEMBER' },
    { 'label': 'Visitor & Member', 'value': 'VISITOR_MEMBER' },
    { 'label': 'No charge', 'value': 'NO_CHARGE' },
  ],
  'parkingDayConfigTimeType': [
    { 'label': 'Custom', 'value': 'CUSTOM' },
    { 'label': 'All day', 'value': 'ALL_DAY' },
  ],
  'tenantCategory': [
    { 'label': 'Admin', 'value': 'Admin' },
    { 'label': 'Reception Counter', 'value': 'Reception Counter' },
    { 'label': 'Coffee Shop', 'value': 'Coffee Shop' },
    { 'label': 'Sales & Marketing', 'value': 'Sales & Marketing' },
    { 'label': 'Convenience Store', 'value': 'Convenience Store' },
    { 'label': 'Merchandise Shop', 'value': 'Merchandise Shop' },
    { 'label': 'Food & Beverage', 'value': 'Food & Beverage' },
    { 'label': 'Health & Beauty', 'value': 'Health & Beauty' },
    { 'label': 'Gym', 'value': 'Gym' },
    { 'label': 'Anchor tenant', 'value': 'Anchor tenant' },
    { 'label': 'Office', 'value': 'Office' },
  ],
  'parkingTimePeriodStart': [
    { 'label': '00:00', 'value': '00:00' },
    { 'label': '01:00', 'value': '01:00' },
    { 'label': '02:00', 'value': '02:00' },
    { 'label': '03:00', 'value': '03:00' },
    { 'label': '04:00', 'value': '04:00' },
    { 'label': '05:00', 'value': '05:00' },
    { 'label': '06:00', 'value': '06:00' },
    { 'label': '07:00', 'value': '07:00' },
    { 'label': '08:00', 'value': '08:00' },
    { 'label': '09:00', 'value': '09:00' },
    { 'label': '10:00', 'value': '10:00' },
    { 'label': '11:00', 'value': '11:00' },
    { 'label': '12:00', 'value': '12:00' },
    { 'label': '13:00', 'value': '13:00' },
    { 'label': '14:00', 'value': '14:00' },
    { 'label': '15:00', 'value': '15:00' },
    { 'label': '16:00', 'value': '16:00' },
    { 'label': '17:00', 'value': '17:00' },
    { 'label': '18:00', 'value': '18:00' },
    { 'label': '19:00', 'value': '19:00' },
    { 'label': '20:00', 'value': '20:00' },
    { 'label': '21:00', 'value': '21:00' },
    { 'label': '22:00', 'value': '22:00' },
    { 'label': '23:00', 'value': '23:00' },
  ],
  'parkingTimePeriodEnd': [
    { 'label': '00:59', 'value': '00:59' },
    { 'label': '01:59', 'value': '01:59' },
    { 'label': '02:59', 'value': '02:59' },
    { 'label': '03:59', 'value': '03:59' },
    { 'label': '04:59', 'value': '04:59' },
    { 'label': '05:59', 'value': '05:59' },
    { 'label': '06:59', 'value': '06:59' },
    { 'label': '07:59', 'value': '07:59' },
    { 'label': '08:59', 'value': '08:59' },
    { 'label': '09:59', 'value': '09:59' },
    { 'label': '10:59', 'value': '10:59' },
    { 'label': '11:59', 'value': '11:59' },
    { 'label': '12:59', 'value': '12:59' },
    { 'label': '13:59', 'value': '13:59' },
    { 'label': '14:59', 'value': '14:59' },
    { 'label': '15:59', 'value': '15:59' },
    { 'label': '16:59', 'value': '16:59' },
    { 'label': '17:59', 'value': '17:59' },
    { 'label': '18:59', 'value': '18:59' },
    { 'label': '19:59', 'value': '19:59' },
    { 'label': '20:59', 'value': '20:59' },
    { 'label': '21:59', 'value': '21:59' },
    { 'label': '22:59', 'value': '22:59' },
    { 'label': '23:59', 'value': '23:59' },
  ],
  // user profile
  'userProfileCurrentPassword': 'CURRENT',
  'userProfileNewPassword': 'NEW',
  // user role
  'userRoleAccounting': 'ACCOUNTING',
  'userRoleOperation': 'OPERATION',
  'userRoleCashier': 'CASHIER',
  'userRoleAdmin': 'ADMIN',
  // user management
  'userManagementCreate': 'CREATE',
  'userManagementEdit': 'EDIT',
  'userManagementReset': 'RESET',
  'userManagementDelete': 'DELETE',
  'userManagementUsernameExist': 'EXIST',
  'userManagementUsernameFiveChars': 'FIVE',
  // user management input type
  'userInputName': 'NAME',
  'userInputMobilePhone': 'MOBILEPHONE',
  // user status
  'userActive': 'ACTIVE',
  'userInActive': 'INACTIVE',
  // iot device type
  'iotDeviceParkingGate': 'PARKING_GATE',
  // iot position
  'iotPositionIn': 'IN',
  'iotPositionOut': 'OUT',
  // default
  'defaultPageSize': { 'label': '10', 'value': 10 },
  'defaultSortAccountingReport': {
    'key': 'parking-time-in',
    'sort': false, // NOTE: ascending === false, descending === true
  },
  'defaultSortParkingReport': {
    'key': 'parking-time-in',
    'sort': true, // NOTE: ascending === false, descending === true
  },
  'defaultSortUserManagement': {
    'key': 'user-created-date',
    'sort': true, // NOTE: ascending === false, descending === true
  },
  'defaultSortManageMembership': {
    'key': 'tenant-member-ref-no',
    'sort': true, // NOTE: ascending === false, descending === true
  },
  'defaultSortCustomParkingDayConfig': {
    'key': 'start-datetime',
    'sort': true, // NOTE: ascending === false, descending === true
  },
  'defaultFilterPaymentMethod': JSON.stringify({
    'cash': { 'label': 'Cash', 'value': 'CASH', 'select': false, 'keyName': 'cash', 'type': 'payment' },
    'creditCard': { 'label': 'Credit Card', 'value': 'CREDIT_CARD', 'select': false, 'keyName': 'creditCard', 'type': 'payment' },
    'promptpayMobile': { 'label': 'Promptpay Mobile', 'value': 'PP_MOBILE', 'select': false, 'keyName': 'promptpayMobile', 'type': 'payment' },
    'promptpayKiosk': { 'label': 'Promptpay Kiosk', 'value': 'PP_KIOSK', 'select': false, 'keyName': 'promptpayKiosk', 'type': 'payment' },
    'promptpayTablet': { 'label': 'Promptpay Tablet', 'value': 'PP_TABLET', 'select': false, 'keyName': 'promptpayTablet', 'type': 'payment' },
    'promptpayKioskParkingGate': { 'label': 'Promptpay Kiosk Parking Gate', 'value': 'PP_KIOSK_PARKING_GATE', 'select': false, 'keyName': 'promptpayKioskParkingGate', 'type': 'payment' },
    'linePay': { 'label': 'Line Pay', 'value': 'LINEPAY', 'select': false, 'keyName': 'linePay', 'type': 'payment' },
    'ezyPayment': { 'label': 'EZY Payment', 'value': 'PP_MOBILE,PP_KIOSK,PP_TABLET,PP_KIOSK_PARKING_GATE', 'select': false, 'keyName': 'ezyPayment', 'type': 'payment' },
  }),
  'defaultFilterIsRedeem': JSON.stringify({
    'redeem': { 'label': 'มีการ Redeem ค่าจอด', 'value': 'redeem', 'select': false, 'keyName': 'redeem', 'type': 'redeem' },
    'notRedeem': { 'label': 'ไม่มีการ Redeem ค่าจอด', 'value': 'notRedeem', 'select': false, 'keyName': 'notRedeem', 'type': 'redeem' },
  }),
  'defaultFilterParkingStatus': JSON.stringify({
    'in': { 'label': 'รถยังอยู่ในระบบ', 'value': 'IN', 'select': false, 'keyName': 'in', 'type': 'parking-status' },
    'out': { 'label': 'รถไม่อยู่ในระบบ', 'value': 'OUT', 'select': false, 'keyName': 'out', 'type': 'parking-status' },
  }),
  'defaultFilterCreateBy': JSON.stringify({
    'auto': { 'label': 'Auto created', 'value': 'AUTO', 'select': false, 'keyName': 'auto', 'type': 'create-by' },
    'manual': { 'label': 'Manual created', 'value': 'MANUAL', 'select': false, 'keyName': 'manual', 'type': 'create-by' },
  }),
  'defaultFilterProblem': JSON.stringify({
    'barrier': { 'label': 'ปัญหาไม้กั้น', 'value': 'GATE_BARRIER_MALFUNCTION_PROBLEM', 'select': false, 'keyName': 'barrier', 'type': 'problem' },
    'payment': { 'label': 'ปัญหาระบบชำระเงิน', 'value': 'PAYMENT_PROBLEM', 'select': false, 'keyName': 'payment', 'type': 'problem' },
    'readVehicleLicensePlate': { 'label': 'ปัญหาระบบอ่านป้าย', 'value': 'READ_VEHICLE_LICENSE_PROBLEM', 'select': false, 'keyName': 'readVehicleLicensePlate', 'type': 'problem' },
    'overdue': { 'label': 'ปัญหาลูกค้ามียอดค้างชำระ', 'value': 'PARKING_FEE_OVERDUE_PROBLEM', 'select': false, 'keyName': 'overdue', 'type': 'problem' },
    'physicalDamage': { 'label': 'ปัญหาป้ายซีดจาง ไม่ชัด หรือ ชำรุด', 'value': 'VEHICLE_LICENSE_PHYSICAL_DAMAGE_PROBLEM', 'select': false, 'keyName': 'physicalDamage', 'type': 'problem' },
    'other': { 'label': 'ปัญหาอื่นๆ', 'value': 'OTHER_PROBLEM', 'select': false, 'keyName': 'other', 'type': 'problem' },
    'noProblem': { 'label': 'ไม่พบปัญหา', 'value': 'NO_PROBLEM', 'select': false, 'keyName': 'noProblem', 'type': 'problem' },
  }),
  'defaultFilterFines': JSON.stringify({
    'hasFines': { 'label': 'มีค่าปรับ', 'value': 'hasFines', 'select': false, 'keyName': 'hasFines', 'type': 'fines' },
    'notFines': { 'label': 'ไม่มีค่าปรับ', 'value': 'notFines', 'select': false, 'keyName': 'notFines', 'type': 'fines' },
  }),
  'defaultFilterVehicleType': JSON.stringify({
    'car': { 'label': 'รถยนต์', 'value': 'CAR', 'select': false, 'keyName': 'car', 'type': 'vehicle-type' },
    'motorcycle': { 'label': 'รถจักรยานยนต์', 'value': 'MOTORCYCLE', 'select': false, 'keyName': 'motorcycle', 'type': 'vehicle-type' },
  }),
  'defaultFilterCustomerType': JSON.stringify({
    'visitor': { 'label': 'visitor', 'value': 'VISITOR', 'select': false, 'keyName': 'visitor', 'type': 'customer-type' },
    'member': { 'label': 'member', 'value': 'MEMBER', 'select': false, 'keyName': 'member', 'type': 'customer-type' },
  }),
  'defaultFilterMemberStatus': JSON.stringify({
    'active': { 'label': 'Active', 'value': 'ACTIVE', 'select': false, 'keyName': 'active', 'type': 'member-status' },
    'inactive': { 'label': 'Inactive', 'value': 'INACTIVE', 'select': false, 'keyName': 'inactive', 'type': 'member-status' },
    'expired': { 'label': 'Expired', 'value': 'EXPIRED', 'select': false, 'keyName': 'expired', 'type': 'member-status' },
  }),
  // trow error
  'trowErrorParkingNotFound': 'failed to summarize parking fees: parking data not found',
  'trowErrorCreateParkingAlreadyExist': 'failed to create parking resource: vehicle’s license plate already exist',
  'trowErrorCreateMembership': 'failed to create tenant member resource: the tenant member’s vehicle already exists in this building',
  'trowErrorUpdateMembership': 'failed to update tenant member resource: the tenant member’s vehicle already exists in this building',
  'trowErrorUsernameAlreadyExist': 'failed to create user resource: username already exist',
  'trowErrorUsernameCharacter': 'failed to create user resource: username must be over or equal 5 characters',
  'throwErrorParkingZoneNotAllow': 'failed to create parking resource: parking zone is not allow this customer type',
  // parking gate location
  'parkingGateLocation': [
    { 'label': 'In', 'value': 'IN' },
    { 'label': 'Out', 'value': 'OUT' },
  ],
  // province
  'province': [
    { 'label': 'กรุงเทพมหานคร', 'value': 'กรุงเทพมหานคร' },
    { 'label': 'กระบี่', 'value': 'กระบี่' },
    { 'label': 'กาญจนบุรี', 'value': 'กาญจนบุรี' },
    { 'label': 'กาฬสินธุ์', 'value': 'กาฬสินธุ์' },
    { 'label': 'กำแพงเพชร', 'value': 'กำแพงเพชร' },
    { 'label': 'ขอนแก่น', 'value': 'ขอนแก่น' },
    { 'label': 'จันทบุรี', 'value': 'จันทบุรี' },
    { 'label': 'ฉะเชิงเทรา', 'value': 'ฉะเชิงเทรา' },
    { 'label': 'ชลบุรี', 'value': 'ชลบุรี' },
    { 'label': 'ชัยนาท', 'value': 'ชัยนาท' },
    { 'label': 'ชัยภูมิ', 'value': 'ชัยภูมิ' },
    { 'label': 'ชุมพร', 'value': 'ชุมพร' },
    { 'label': 'เชียงราย', 'value': 'เชียงราย' },
    { 'label': 'เชียงใหม่', 'value': 'เชียงใหม่' },
    { 'label': 'ตรัง', 'value': 'ตรัง' },
    { 'label': 'ตราด', 'value': 'ตราด' },
    { 'label': 'ตาก', 'value': 'ตาก' },
    { 'label': 'นครนายก', 'value': 'นครนายก' },
    { 'label': 'นครปฐม', 'value': 'นครปฐม' },
    { 'label': 'นครพนม', 'value': 'นครพนม' },
    { 'label': 'นครราชสีมา', 'value': 'นครราชสีมา' },
    { 'label': 'นครศรีธรรมราช', 'value': 'นครศรีธรรมราช' },
    { 'label': 'นครสวรรค์', 'value': 'นครสวรรค์' },
    { 'label': 'นนทบุรี', 'value': 'นนทบุรี' },
    { 'label': 'นราธิวาส', 'value': 'นราธิวาส' },
    { 'label': 'น่าน', 'value': 'น่าน' },
    { 'label': 'หนองคาย', 'value': 'หนองคาย' },
    { 'label': 'หนองบัวลำภู', 'value': 'หนองบัวลำภู' },
    { 'label': 'บึงกาฬ', 'value': 'บึงกาฬ' },
    { 'label': 'บุรีรัมย์', 'value': 'บุรีรัมย์' },
    { 'label': 'ปทุมธานี', 'value': 'ปทุมธานี' },
    { 'label': 'ประจวบคีรีขันธ์', 'value': 'ประจวบคีรีขันธ์' },
    { 'label': 'ปราจีนบุรี', 'value': 'ปราจีนบุรี' },
    { 'label': 'ปัตตานี', 'value': 'ปัตตานี' },
    { 'label': 'พระนครศรีอยุธยา', 'value': 'พระนครศรีอยุธยา' },
    { 'label': 'พังงา', 'value': 'พังงา' },
    { 'label': 'พัทลุง', 'value': 'พัทลุง' },
    { 'label': 'พิจิตร', 'value': 'พิจิตร' },
    { 'label': 'พิษณุโลก', 'value': 'พิษณุโลก' },
    { 'label': 'เพชรบุรี', 'value': 'เพชรบุรี' },
    { 'label': 'เพชรบูรณ์', 'value': 'เพชรบูรณ์' },
    { 'label': 'แพร่', 'value': 'แพร่' },
    { 'label': 'พะเยา', 'value': 'พะเยา' },
    { 'label': 'ภูเก็ต', 'value': 'ภูเก็ต' },
    { 'label': 'มหาสารคาม', 'value': 'มหาสารคาม' },
    { 'label': 'แม่ฮ่องสอน', 'value': 'แม่ฮ่องสอน' },
    { 'label': 'มุกดาหาร', 'value': 'มุกดาหาร' },
    { 'label': 'ยะลา', 'value': 'ยะลา' },
    { 'label': 'เบตง', 'value': 'เบตง' },
    { 'label': 'ยโสธร', 'value': 'ยโสธร' },
    { 'label': 'ร้อยเอ็ด', 'value': 'ร้อยเอ็ด' },
    { 'label': 'ระนอง', 'value': 'ระนอง' },
    { 'label': 'ระยอง', 'value': 'ระยอง' },
    { 'label': 'ราชบุรี', 'value': 'ราชบุรี' },
    { 'label': 'ลพบุรี', 'value': 'ลพบุรี' },
    { 'label': 'ลำปาง', 'value': 'ลำปาง' },
    { 'label': 'ลำพูน', 'value': 'ลำพูน' },
    { 'label': 'เลย', 'value': 'เลย' },
    { 'label': 'ศรีสะเกษ', 'value': 'ศรีสะเกษ' },
    { 'label': 'สกลนคร', 'value': 'สกลนคร' },
    { 'label': 'สงขลา', 'value': 'สงขลา' },
    { 'label': 'สตูล', 'value': 'สตูล' },
    { 'label': 'สมุทรปราการ', 'value': 'สมุทรปราการ' },
    { 'label': 'สมุทรสงคราม', 'value': 'สมุทรสงคราม' },
    { 'label': 'สมุทรสาคร', 'value': 'สมุทรสาคร' },
    { 'label': 'สระแก้ว', 'value': 'สระแก้ว' },
    { 'label': 'สระบุรี', 'value': 'สระบุรี' },
    { 'label': 'สิงห์บุรี', 'value': 'สิงห์บุรี' },
    { 'label': 'สุโขทัย', 'value': 'สุโขทัย' },
    { 'label': 'สุพรรณบุรี', 'value': 'สุพรรณบุรี' },
    { 'label': 'สุราษฎร์ธานี', 'value': 'สุราษฎร์ธานี' },
    { 'label': 'สุรินทร์', 'value': 'สุรินทร์' },
    { 'label': 'อ่างทอง', 'value': 'อ่างทอง' },
    { 'label': 'อุดรธานี', 'value': 'อุดรธานี' },
    { 'label': 'อุทัยธานี', 'value': 'อุทัยธานี' },
    { 'label': 'อุตรดิตถ์', 'value': 'อุตรดิตถ์' },
    { 'label': 'อุบลราชธานี', 'value': 'อุบลราชธานี' },
    { 'label': 'อำนาจเจริญ', 'value': 'อำนาจเจริญ' },
  ],
  // vehicle brand
  'vehicleBrand': [
    { 'label': 'Alfa Romeo', 'value': 'Alfa Romeo' },
    { 'label': 'Aston Martin', 'value': 'Aston Martin' },
    { 'label': 'Audi', 'value': 'Audi' },
    { 'label': 'BMW', 'value': 'BMW' },
    { 'label': 'Bentley', 'value': 'Bentley' },
    { 'label': 'Chevrolet', 'value': 'Chevrolet' },
    { 'label': 'Citroen', 'value': 'Citroen' },
    { 'label': 'Ferrari', 'value': 'Ferrari' },
    { 'label': 'Fiat', 'value': 'Fiat' },
    { 'label': 'Ford', 'value': 'Ford' },
    { 'label': 'Hino', 'value': 'Hino' },
    { 'label': 'Honda', 'value': 'Honda' },
    { 'label': 'Hyundai', 'value': 'Hyundai' },
    { 'label': 'Isuzu', 'value': 'Isuzu' },
    { 'label': 'Jaguar', 'value': 'Jaguar' },
    { 'label': 'Jeep', 'value': 'Jeep' },
    { 'label': 'KIA', 'value': 'KIA' },
    { 'label': 'Lamborghini', 'value': 'Lamborghini' },
    { 'label': 'Land Rover', 'value': 'Land Rover' },
    { 'label': 'Lexus', 'value': 'Lexus' },
    { 'label': 'MG', 'value': 'MG' },
    { 'label': 'Maserati', 'value': 'Maserati' },
    { 'label': 'Mazda', 'value': 'Mazda' },
    { 'label': 'Mercedes-Benze', 'value': 'Mercedes-Benze' },
    { 'label': 'Mini', 'value': 'Mini' },
    { 'label': 'Mitsubishi', 'value': 'Mitsubishi' },
    { 'label': 'Nissan', 'value': 'Nissan' },
    { 'label': 'Peugeot', 'value': 'Peugeot' },
    { 'label': 'Porsche', 'value': 'Porsche' },
    { 'label': 'Renault', 'value': 'Renault' },
    { 'label': 'Rolls-Royce', 'value': 'Rolls-Royce' },
    { 'label': 'Subaru', 'value': 'Subaru' },
    { 'label': 'Suzuki', 'value': 'Suzuki' },
    { 'label': 'Tesla', 'value': 'Tesla' },
    { 'label': 'Toyota', 'value': 'Toyota' },
    { 'label': 'Volkswagen', 'value': 'Volkswagen' },
    { 'label': 'Volvo', 'value': 'Volvo' },
    { 'label': 'Orther', 'value': 'Orther' },
  ],
};
